import { XIcon } from "@heroicons/react/outline";
import { CheckCircleIcon } from "@heroicons/react/solid";
import React from "react";

const AlertModal = ({ title, show, onCloseCallback }) => {
  if (!show) {
    return null;
  }

  return (
    <div
      id="popup-modal"
      tabIndex="-1"
      className="fixed top-0 right-0 left-0 bottom-0 overflow-y-auto overflow-x-hidden flex justify-center items-center z-50 md:inset-0 h-modal md:h-full bg-[rgba(0,0,0,0.6)]"
    >
      <div className="relative p-4 w-full max-w-md h-full md:h-auto">
        {/* <!-- Modal content --> */}
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          {/* <!-- Modal header --> */}
          <div className="flex justify-end">
            <button
              onClick={() => onCloseCallback()}
              type="button"
              className="rounded-lg text-sm ml-auto p-4 inline-flex items-center"
              data-modal-toggle="popup-modal"
            >
              <XIcon className="w-5 h-5" />
            </button>
          </div>
          {/* <!-- Modal body --> */}
          <div className="p-6 pt-0 text-center">
            <CheckCircleIcon className="mx-auto mb-4 w-14 h-14 fill-green-600" />
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              {title}
            </h3>
            <button
              onClick={() => onCloseCallback()}
              data-modal-toggle="popup-modal"
              type="button"
              className="text-white bg-[#5C5CC0] hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            >
              OKAY!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
